import Vue from 'vue'

/* Filters */
import CurrencyFormat from './filters/CurrencyFormat/CurrencyFormat'

/* Components */
import './components/CheckoutForms'
import './components/AppPreview'
import './components/AppTabs'
import './components/AppDialog'
import SVGLoader from './components/SVGLoader/SVGLoader'
import LoadingArea from './components/LoadingArea/LoadingArea'
import FontLoader from './components/FontLoader/FontLoader'
import ProductLogo from './components/ProductLogo/ProductLogo'
import CheckoutTags from './components/CheckoutTags/CheckoutTags'
import CheckoutTag from './components/CheckoutTags/CheckoutTag'
import PlatformSelector from './components/PlatformSelector/PlatformSelector'
import ContentScroller from './components/ContentScroller/ContentScroller'
import CheckoutOverlay from './components/CheckoutOverlay/CheckoutOverlay'
import ClickoutOverlay from './components/ClickoutOverlay/ClickoutOverlay'
import CheckoutOverlayActions from './components/CheckoutOverlay/components/CheckoutOverlayActions'
import CheckoutOverlayButton from './components/CheckoutOverlay/components/CheckoutOverlayButton'
import CheckoutOverlayBody from './components/CheckoutOverlay/components/CheckoutOverlayBody'
import CheckoutOverlayCombo from './components/CheckoutOverlay/components/CheckoutOverlayCombo'
import CheckoutOverlayComboItem from './components/CheckoutOverlay/components/CheckoutOverlayComboItem'
import CheckoutOverlayCheck from './components/CheckoutOverlay/components/CheckoutOverlayCheck'
import CheckoutOverlaySeparator from './components/CheckoutOverlay/components/CheckoutOverlaySeparator'
import CheckoutOverlayTitle from './components/CheckoutOverlay/components/CheckoutOverlayTitle'
import CheckoutOverlayText from './components/CheckoutOverlay/components/CheckoutOverlayText'
import CheckoutOverlayExpandedContent from './components/CheckoutOverlay/components/CheckoutOverlayExpandedContent'
import NotificationManager from './components/NotificationManager/NotificationManager'
import ButtonEl from './components/ButtonEl/ButtonEl'
import RenderPortal from './components/RenderPortal/RenderPortal'

Vue.filter(CurrencyFormat.name, CurrencyFormat.filter)
Vue.component(SVGLoader.name, SVGLoader)
Vue.component(LoadingArea.name, LoadingArea)
Vue.component(FontLoader.name, FontLoader)
Vue.component(ProductLogo.name, ProductLogo)
Vue.component(CheckoutTags.name, CheckoutTags)
Vue.component(CheckoutTag.name, CheckoutTag)
Vue.component(PlatformSelector.name, PlatformSelector)
Vue.component(ContentScroller.name, ContentScroller)
Vue.component(CheckoutOverlay.name, CheckoutOverlay)
Vue.component(ClickoutOverlay.name, ClickoutOverlay)
Vue.component(CheckoutOverlayActions.name, CheckoutOverlayActions)
Vue.component(CheckoutOverlayButton.name, CheckoutOverlayButton)
Vue.component(CheckoutOverlayBody.name, CheckoutOverlayBody)
Vue.component(CheckoutOverlayCombo.name, CheckoutOverlayCombo)
Vue.component(CheckoutOverlayComboItem.name, CheckoutOverlayComboItem)
Vue.component(CheckoutOverlayCheck.name, CheckoutOverlayCheck)
Vue.component(CheckoutOverlaySeparator.name, CheckoutOverlaySeparator)
Vue.component(CheckoutOverlayTitle.name, CheckoutOverlayTitle)
Vue.component(CheckoutOverlayText.name, CheckoutOverlayText)
Vue.component(CheckoutOverlayExpandedContent.name, CheckoutOverlayExpandedContent)
Vue.component(NotificationManager.name, NotificationManager)
Vue.component(ButtonEl.name, ButtonEl)
Vue.component(RenderPortal.name, RenderPortal)
